import { brand, grey } from '@pelotoncycle/design-system';
import { pathOr } from 'ramda';
import { snowWhite, white } from '@ecomm/colors';

export type Theme = keyof typeof THEMES;

const defaultTheme = {
  contentBackground: brand.dark,
  desktopLargeContentAlignment: 'center',
  desktopLargeContentPadding: '50px 55px',
  desktopXLargeContentPadding: '50px 0',
  headingColor: snowWhite,
  bodyColor: white,
  financingColor: white,
  finePrintColor: white,
  underlineColor: grey[70],
  maxContentWidth: '350px',
};

export const THEMES = {
  homepage: {
    ...defaultTheme,
  },
  holiday: {
    ...defaultTheme,
    desktopLargeContentAlignment: 'flex-start',
    desktopLargeContentPadding: '70px 50px',
    desktopXLargeContentPadding: '20% 90px',
    financingColor: grey[70],
    maxContentWidth: '420px',
  },
  hero: {
    ...defaultTheme,
    desktopLargeContentPadding: '100px 8%',
    desktopXLargeContentPadding: '100px 120px',
  },
};

export const activeTheme = (theme: Theme, themeProp: string): string =>
  pathOr('undefined', [theme, themeProp], THEMES); // TODO: yikes
